import { Link } from "react-router-dom";
import { useOrganizationsControllerGet } from "@/api/__generated__/orval/accounts";

type OrganizationBreadcrumbProps = {
  accountId: string;
  organizationId: string;
};

export const OrganizationBreadcrumb = ({
  accountId,
  organizationId,
}: OrganizationBreadcrumbProps) => {
  const { data: organizationData, isPending } = useOrganizationsControllerGet(
    accountId,
    organizationId
  );

  const name =
    organizationData?.status === 200 ? organizationData.data.data.name : "...";

  if (isPending) {
    return <>...</>;
  }

  return (
    <Link to={`/admin/account/${accountId}/organization/${organizationId}`}>
      {name}
    </Link>
  );
};
